const strings = {
  title: 'Agricultores',
  subtitle: 'Detalhes',
}

export default strings
